import React, { useCallback, useEffect, useRef } from 'react';
import { shouldProcessMouseEvents } from '../utils';

interface Props {
  onNavigationLeave: () => void;
}

const DELAY = 500;

interface NavigationDismissDelayHelpersProps {
  onMouseLeaveNavigation: React.MouseEventHandler;
  clearDismissTimeout: () => void;
}

export const useNavigationDismissDelay = ({ onNavigationLeave }: Props): NavigationDismissDelayHelpersProps => {
  const leaveNavigationTimerRef = useRef<number>();

  const clearDismissTimeout = useCallback(() => {
    clearTimeout(leaveNavigationTimerRef.current);
  }, []);

  useEffect(
    () => () => {
      clearDismissTimeout();
    },
    [clearDismissTimeout]
  );

  const dismissWithDelay = useCallback(() => {
    const delay = DELAY;
    const timeoutId = window.setTimeout(() => {
      onNavigationLeave();
    }, delay);
    leaveNavigationTimerRef.current = timeoutId;
  }, [onNavigationLeave]);

  const mouseLeaveNavigation = useCallback(() => {
    if (shouldProcessMouseEvents()) {
      clearDismissTimeout();
      dismissWithDelay();
    }
  }, [clearDismissTimeout, dismissWithDelay]);

  return {
    onMouseLeaveNavigation: mouseLeaveNavigation,
    clearDismissTimeout,
  };
};
